/* ===== Anadita Luxe — hero background image rotation ===== */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('[data-hero-rotate]').forEach(function (root) {
    var images = [].slice.call(root.querySelectorAll('.hero__image'));
    if (images.length < 2) return;
    var speed = parseFloat(root.getAttribute('data-hero-speed')) || 6;
    var index = images.findIndex(function (img) { return img.classList.contains('is-active'); });
    if (index < 0) index = 0;
    setInterval(function () {
      images[index].classList.remove('is-active');
      index = (index + 1) % images.length;
      images[index].classList.add('is-active');
    }, speed * 1000);
  });
})();
